import React from 'react';
import PropTypes from 'prop-types';
import { Button, P, Link } from '@decisiv/ui-components';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import ArrowRight from '@decisiv/iconix/lib/components/ArrowRight';
import ArrowLeft from '@decisiv/iconix/lib/components/ArrowLeft';
import { ConflictText, InstructionsDiv, Padding } from './styledComponents';
import { REQUEST_EMAIL } from '../constants';
import { interpolate, escapeHtml } from '../utils';

function ConflictScreen({ requestType, value, onBack, onContinue, translations }) {
  const channel =
    requestType === REQUEST_EMAIL
      ? translations.channelEmailAddress
      : translations.channelMobile;

  // value is user-supplied, so escape it before interpolating into the HTML.
  const inUseMarkup = {
    __html: interpolate(translations.conflictInUseHtml, {
      channel,
      value: escapeHtml(value),
    }),
  };

  return (
    <Padding>
      <P
        style={{
          fontSize: '16px',
          color: toColorString(color.base.alaskanHusky),
        }}
      >
        {/* eslint-disable-next-line react/no-danger */}
        <ConflictText dangerouslySetInnerHTML={inUseMarkup} />
      </P>
      <P
        style={{
          fontWeight: 400,
          color: toColorString(color.base.alaskanHusky),
        }}
      >
        {interpolate(translations.conflictCannotAdd, { channel })}
      </P>
      <P
        style={{
          fontWeight: 400,
          color: toColorString(color.base.alaskanHusky),
        }}
      >
        {translations.conflictContactAdvisor}
      </P>
      <Flex marginTop={2}>
        <Button
          icon={ArrowRight}
          text={translations.continueToPortal}
          iconPosition="right"
          onClick={() => onContinue()}
        />
      </Flex>
      <Flex marginTop={2}>
        <Button
          icon={ArrowLeft}
          text={translations.previousPage}
          iconPosition="left"
          kind="secondary"
          onClick={() => onBack()}
        />
      </Flex>
      <Flex marginTop={4} flexDirection="column">
        <InstructionsDiv>
          <P
            style={{
              fontWeight: 600,
            }}
          >
            {translations.conflictWhyTitle}{' '}
          </P>
          <P
            style={{
              fontWeight: 400,
            }}
          >
            {translations.conflictWhyBody}
          </P>
        </InstructionsDiv>
      </Flex>
      <Flex marginTop={2}>
        <Link to="/" size="small" text={translations.helpDeskMultipleAccounts} />
      </Flex>
    </Padding>
  );
}

ConflictScreen.propTypes = {
  requestType: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  translations: PropTypes.objectOf(PropTypes.string),
};

ConflictScreen.defaultProps = {
  translations: {},
};

export default ConflictScreen;
